/* tslint:disable */
/* eslint-disable */
export enum IntegrationType {
  Shopify = 'Shopify',
  GoogleAds = 'GoogleAds',
  Amazon = 'Amazon',
  CustomPgqlDb = 'CustomPgqlDb'
}
